const ModalsEnum = {
    UPLOAD_AND_GENERATE_MODAL: 1,
    GENERATE_YOUR_QUIZ_MODAL: 2,
    QUIZ_QUESTIONS_MODAL: 3,
    LOADING_MODAL: 4,
    CANCEL_SUBSCRIPTION_MODAL: 5,
    CONFIRM_CANCELATION_MODAL: 6,
    PAUSE_SUBSCRIPTION_MODAL: 7,
    LIMIT_REACHED_MODAL: 8,
    SUBSCRIPTION_CANCELED_MODAL: 9,
};

export default ModalsEnum;
